module.exports = __webpack_public_path__ + "media/images/lb/992-20071f9069c1631151a335bcd8fbcb92.svg";